
export { default as ViewProfileModal } from './Profile'


// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-decision/SessionList/Modals/index.js